const MobileNavigation = {
    closeTimer: null,
    screenHistory: ["root"],

    init() {
        $(document).on("pointerdown", ".mobile-navigation__item, .mobile-more__category, .mobile-more__link, .mobile-more__back, .mobile-more__close", function (event) {
            const item = $(this);
            const element = item.get(0);
            const bounds = element.getBoundingClientRect();
            const size = Math.max(bounds.width, bounds.height) * 1.8;
            const ripple = $('<span class="mobile-navigation__ripple" aria-hidden="true"></span>');

            ripple.css({
                width: size,
                height: size,
                left: event.clientX - bounds.left - size / 2,
                top: event.clientY - bounds.top - size / 2,
            });
            item.find(".mobile-navigation__ripple").remove();
            item.append(ripple);
            window.setTimeout(() => ripple.remove(), 520);
        });

        $(document).on("click", "[data-mobile-more]", function () {
            MobileNavigation.open();
        });

        $(document).on("click", "[data-mobile-menu-close]", function () {
            MobileNavigation.close();
        });

        $(document).on("click", "[data-mobile-menu-target]", function () {
            MobileNavigation.showScreen($(this).data("mobile-menu-target"), false, true);
        });

        $(document).on("click", "[data-mobile-menu-back]", function () {
            MobileNavigation.goBack();
        });

        $(document).on("click", "[data-mobile-more-overlay] a", function () {
            MobileNavigation.close();
        });

        $(document).on("keydown", function (event) {
            if (event.key === "Escape") MobileNavigation.close();
        });
    },

    open() {
        const overlay = $("[data-mobile-more-overlay]");
        if (!overlay.length) return;

        window.clearTimeout(this.closeTimer);
        this.screenHistory = ["root"];
        this.showScreen("root");
        overlay.prop("hidden", false);
        $("[data-mobile-more]").attr("aria-expanded", "true").addClass("is-active");
        $("body").addClass("mobile-menu-open");
        window.requestAnimationFrame(() => {
            overlay.addClass("is-open");
            overlay.find(".mobile-more__close").trigger("focus");
        });
    },

    close() {
        const overlay = $("[data-mobile-more-overlay]");
        if (!overlay.length || overlay.prop("hidden")) return;

        overlay.removeClass("is-open");
        $("[data-mobile-more]").attr("aria-expanded", "false").removeClass("is-active");
        $("body").removeClass("mobile-menu-open");
        this.closeTimer = window.setTimeout(() => {
            overlay.prop("hidden", true);
            this.screenHistory = ["root"];
            this.showScreen("root");
        }, 220);
    },

    showScreen(name, backwards = false, addToHistory = false) {
        const overlay = $("[data-mobile-more-overlay]");
        const screens = overlay.find("[data-mobile-menu-screen]");
        const next = screens.filter('[data-mobile-menu-screen="' + name + '"]');
        if (!next.length) return;

        if (addToHistory && this.screenHistory[this.screenHistory.length - 1] !== name) {
            this.screenHistory.push(name);
        }

        screens.removeClass("is-active is-entering is-entering-back").prop("hidden", true);
        next.prop("hidden", false).addClass("is-active " + (backwards ? "is-entering-back" : "is-entering"));
        overlay.find("[data-mobile-menu-title]").text(next.data("title"));
        overlay.find("[data-mobile-menu-back]").prop("hidden", this.screenHistory.length <= 1);
    },

    goBack() {
        if (this.screenHistory.length <= 1) return;
        this.screenHistory.pop();
        this.showScreen(this.screenHistory[this.screenHistory.length - 1], true);
    },
};

export default MobileNavigation;
